import React from 'react';
import { iconByName } from '../../lib/iconRegistry.js';

/**
 * Icon — renders a Lucide glyph (BRAND.md §7: no emoji in UI; one Lucide
 * icon set, 1.75px stroke, currentColor). Looks up `name` in
 * src/lib/iconRegistry.js (the npm `lucide-react` package, tree-shaken) —
 * an unknown name renders nothing rather than crashing.
 */
export function Icon({ name, size = 20, strokeWidth = 1.75, color = 'currentColor', style, className, title, ...rest }) {
  const LucideIcon = iconByName(name);
  if (!LucideIcon) return null;
  return (
    <LucideIcon
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : 'true'}
      aria-label={title}
      style={{ display: 'inline-block', verticalAlign: '-0.125em', flexShrink: 0, ...style }}
      className={className}
      {...rest}
    />
  );
}
